// @ts-ignore
import sanitizeHtml from 'sanitize-html';

/**
 * Allows only basic text formatting.
 * Used in notifications.
 */
export const RESTRICTIVE_SANITIZER_OPTIONS = {
	allowedTags: ['b', 'br', 'i', 'p'],
	disallowedTagsMode: 'recursiveEscape',
	allowedAttributes: {},
	selfClosing: [],
	allowedSchemes: [],
	allowedSchemesByTag: {},
	allowedSchemesAppliedToAttributes: [],
	allowProtocolRelative: false,
};

/**
 * Allows more complex formatting - tables, links etc.
 * Adds to library defaults - @see https://www.npmjs.com/package/sanitize-html
 */
export const DEFAULT_SANITIZER_OPTIONS = {
	allowedTags: [
		'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
		'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'abbr', 'code', 'hr', 'br', 'div',
		'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'iframe',
		'colgroup', 'col', 'span',
	],
	disallowedTagsMode: 'recursiveEscape',
	allowedSchemes: ['http', 'https'],
	allowedAttributes: { a: ['href'], img: ['src', 'width', 'height'] },
};

export function sanitize(val: string, options: object = DEFAULT_SANITIZER_OPTIONS): string {
	return sanitizeHtml(val, options);
}
